import React, { useState, useRef, useEffect } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../../contexts/AuthContext";
import "./Header.css";
import logo from "../../assets/logo.svg";
import {
    Edit2
} from "lucide-react";

const Header: React.FC = () => {
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const profileMenuRef = useRef<HTMLDivElement>(null);
    const location = useLocation();
    const currentPath = location.pathname;

    const handleLogout = () => {
        axios
            .post("/users/logout", {})
            .then(() => setUser(null))
            .catch((err) => console.error(err));
        setIsProfileMenuOpen(false);
        setIsMobileMenuOpen(false);
    };

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                profileMenuRef.current &&
                !profileMenuRef.current.contains(event.target as Node)
            ) {
                setIsProfileMenuOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    return (
        <header className="header-container">
            <div className="header-content">
                <div className="header-left">
                    <Link to="/" className="header-logo-link">
                        <img src={logo} alt="Logo" className="header-logo" />
                    </Link>
                </div>

                <div className="hamburger-menu" onClick={toggleMobileMenu}>
                    <div className={`hamburger-icon ${isMobileMenuOpen ? "open" : ""}`}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>

                {isMobileMenuOpen && (
                    <div className="mobile-menu">
                        <nav className="header-nav mobile">
                            <button
                                className={`header-nav-item ${(currentPath === "/" || currentPath === "/accounts") ? "header-nav-item-active" : ""}`}
                                onClick={() => {
                                    if (window.location.pathname !== "/accounts") {
                                        navigate("/accounts");
                                    }
                                    setIsMobileMenuOpen(false);
                                }}
                            >
                                <span className="header-nav-icon header-icon-gamepad"></span>
                                <span>Accounts</span>
                            </button>
                            <button
                                className={`header-nav-item ${currentPath === "/prompt-editor" ? "header-nav-item-active" : ""}`}
                                onClick={() => {
                                    if (window.location.pathname !== "/prompt-editor") {
                                        navigate("/prompt-editor");
                                    }
                                    setIsMobileMenuOpen(false);
                                }}
                            >
                                <Edit2 size={16} />
                                <span>Prompt Editor</span>
                            </button>
                        </nav>
                    </div>
                )}

                <div className="header-center desktop-only">
                    <nav className="header-nav">
                        <button
                            className={`header-nav-item ${(currentPath === "/" || currentPath === "/accounts") ? "header-nav-item-active" : ""}`}
                            onClick={() => {
                                if (window.location.pathname !== "/accounts") {
                                    navigate("/accounts");
                                }
                            }}
                        >
                            <span className="header-nav-icon header-icon-gamepad"></span>
                            <span>Accounts</span>
                        </button>
                        <button
                            className={`header-nav-item ${currentPath === "/prompt-editor" ? "header-nav-item-active" : ""}`}
                            onClick={() => {
                                if (window.location.pathname !== "/prompt-editor") {
                                    navigate("/prompt-editor");
                                }
                            }}
                        >
                            <Edit2 size={16} />
                            <span>Prompt Editor</span>
                        </button>
                    </nav>
                </div>

                <div className="header-right" ref={profileMenuRef}>
                    <div
                        className="header-profile"
                        onClick={() => setIsProfileMenuOpen(!isProfileMenuOpen)}
                    >
                        <img src={logo} alt="Profile" className="header-profile-image" />
                        <div
                            className={`header-chevron ${isProfileMenuOpen ? "header-chevron-up" : ""
                                }`}
                        ></div>
                    </div>

                    {isProfileMenuOpen && (
                        <div className="header-profile-menu">
                            <button className="header-profile-menu-item">
                                <span className="header-menu-icon header-icon-settings"></span>
                                Settings
                            </button>
                            <button
                                className="header-profile-menu-item header-logout-button"
                                onClick={handleLogout}
                            >
                                <span className="header-menu-icon header-icon-logout"></span>
                                Logout
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </header>
    );
};

export default Header;
